import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useDeviceInfo } from '@/offline'
import { usePhoneSession } from '@/auth/pin/phoneSession'
import { FullScreenSpinner } from '@/auth/guards'

/** The phone must be registered, not revoked, and have its roster/site cache. Else → setup. */
export function RequireDeviceReady({ children }: { children?: ReactNode }) {
  const info = useDeviceInfo()
  if (!info.loaded) return <FullScreenSpinner />
  if (
    !info.registration ||
    info.registration.status === 'REVOKED' ||
    info.freshness === 'missing'
  ) {
    return <Navigate to="/m/setup" replace />
  }
  return children ? <>{children}</> : <Outlet />
}

/** A team member must have unlocked with their PIN. Else → PIN screen, then back here. */
export function RequireUnlocked({ children }: { children?: ReactNode }) {
  const { actor } = usePhoneSession()
  const location = useLocation()
  if (!actor)
    return <Navigate to="/m/unlock" replace state={{ from: location.pathname + location.search }} />
  return children ? <>{children}</> : <Outlet />
}
